import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {militaryPayCalculator_template} from "../components/templates/militaryPayCalculator_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class military_pay_calculator extends vnModule_knockoutJS{

    protected militaryPayCalculatorForm : militaryPayCalculator_template
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {

        this.militaryPayCalculatorForm = new militaryPayCalculator_template('militaryPayCalculatorTemplate', this.viewModel, this);
        return [this.militaryPayCalculatorForm.build()]
    }

    protected getModuleName(): string {

        return "military_pay_calculator";
    }

    public fillPage() {
        const year = new Date().getFullYear();
        this.loadingIn(this.militaryPayCalculatorForm.builtTemplate);
        this.setSaveStatus('Loading saved config...');

        this.getSavedConfig(year).then((config) => {
            if (config && !Array.isArray(config) && config.payload && this.militaryPayCalculatorForm && typeof (this.militaryPayCalculatorForm as any).populateFromPayload === 'function') {
                this.militaryPayCalculatorForm.populateFromPayload(config.payload);
                this.setSaveStatus('Loaded saved config');
                setTimeout(() => this.setSaveStatus(''), 3000);
                this.loadingOut(this.militaryPayCalculatorForm.builtTemplate);
                return;
            }

            this.setSaveStatus('');
            this.loadingOut(this.militaryPayCalculatorForm.builtTemplate);
        }).catch((err: Error) => {
            this.setSaveStatus('Error: ' + (err.message || 'Load failed'));
            this.loadingOut(this.militaryPayCalculatorForm.builtTemplate);
        });
    }

    protected filterSimpleOnChange(idElement) {

    }

    /**
     * Save parsed pay calculator JSON to the server. Updates template status observable on progress/error.
     */
    public async save(payload: object): Promise<void> {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand == null || idBrand === undefined) {
            this.setSaveStatus('Error: brand not found');
            return Promise.resolve();
        }

        const url = '/api/brand/' + idBrand + '/config/military-pay-calculator/save/';
        this.setSaveStatus('Saving...');

        const body = JSON.stringify({ data: JSON.stringify(payload) });

        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: body,
            credentials: 'same-origin'
        }).then((res) => {
            if (!res.ok) {
                return res.json()
                    .then((err: { error?: string }) => { throw new Error(err.error || res.statusText); })
                    .catch(() => { throw new Error(res.statusText); });
            }
            return res.json();
        }).then(() => {
            this.setSaveStatus('Saved!');
            setTimeout(() => this.setSaveStatus(''), 3000);
        }).catch((err: Error) => {
            this.setSaveStatus('Error: ' + (err.message || 'Save failed'));
        });
    }

    /**
     * Retrieve saved military pay calculator config(s) from the server.
     * @param year - Optional pay_calculator_year to filter by; otherwise returns latest entries.
     */
    public getSavedConfig(year?: number): Promise<{ id: number; payCalculatorYear: number; bahRateYear: number; dateCreated: string; dateUpdated: string; payload: object } | { id: number; payCalculatorYear: number; bahRateYear: number; dateCreated: string; dateUpdated: string; payload: object }[]> {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand == null || idBrand === undefined) {
            return Promise.reject(new Error('Brand not found'));
        }

        let url = '/api/brand/' + idBrand + '/config/military-pay-calculator/get/';
        if (year != null) {
            url += '?year=' + encodeURIComponent(String(year));
        }

        return fetch(url, {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin'
        }).then((res) => {
            if (!res.ok) {
                throw new Error(res.statusText);
            }
            return res.json();
        });
    }

    private setSaveStatus(status: string): void {
        const vm = this.viewModel['militaryPayCalculatorTemplate'];
        if (vm && typeof vm.saveStatus === 'function') {
            vm.saveStatus(status);
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_pay_calculator.ts